import { useRef } from "react";
import ReactSelect from "react-select";

export const MultiSelect = (props) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: "#fff",
      borderColor: "#9e9e9e",
      minHeight: "2.25rem",
      width: "18.125rem",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  const valueRef = useRef(props.value);
  valueRef.current = props.value;

  const selectAllOption = {
    value: "<SELECT_ALL>",
    label: "Select All",
  };

  const isSelectAllSelected = () => {
    const values = Array.isArray(valueRef.current)
      ? valueRef.current
      : [];

    return values.some(
      ({ value }) =>
        value === "*" || value === "<SELECT_ALL>"
    );
  };

  const isOptionSelected = (option) => {
    const values = Array.isArray(valueRef.current)
      ? valueRef.current
      : [];

    if (option.value === selectAllOption.value) {
      return isSelectAllSelected();
    }

    return values.some(({ value }) => value === option.value);
  };

  const getOptions = () => {
    const options = Array.isArray(props.options)
      ? props.options
      : [];

    if (props.isLoading) {
      return [
        {
          label: "Loading...",
          value: "loading",
          isDisabled: true,
        },
      ];
    }

    if (props.enableSelectAll) {
      return [selectAllOption, ...options];
    }

    return options;
  };

  const getValue = () => {
    const values = Array.isArray(props.value)
      ? props.value
      : [];

    if (isSelectAllSelected()) {
      return [selectAllOption];
    }

    return values;
  };

  const onChange = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta;

    if (option?.value === "loading") return;
    if (
      action === "select-option" &&
      option?.value === selectAllOption.value
    ) {
      props.onChange(
        [{ label: "Select All", value: "*" }],
        actionMeta
      );
      return;
    }
    if (
      (action === "deselect-option" &&
        option?.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue?.value === selectAllOption.value)
    ) {
      props.onChange([], actionMeta);
      return;
    }

    props.onChange(newValue || [], actionMeta);
  };

  return (
    <div>
      <ReactSelect
        isOptionSelected={isOptionSelected}
        options={getOptions()}
        value={getValue()}
        onChange={onChange}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        isMulti
        styles={customStyles}
        isDisabled={props.isDisabled}
        isLoading={props.isLoading}
        placeholder={
          props.isLoading
            ? "Loading..."
            : props?.customPlaceHolder || "Select..."
        }
      />
    </div>
  );
};